export const getIsTestEmail = (email: string) => {
  return Boolean(/@test\.com$/i.test(email))
}
